import importReact from "../../utils/importReact";

export default function initSearchPage() {
  const entrypoint = document.getElementById("search-page-container");
  if (entrypoint) {
    import(/* webpackChunkName: "searchPage" */ "./SearchPage").then((e) => {
      const pageSize = parseInt(entrypoint.dataset.pagesize);
      const currentPageRef = parseInt(entrypoint.dataset.currentpage);
      const { noResults, placeholder, searchFor } = entrypoint.dataset;
      importReact().then(([React, ReactDOM]) => {
        ReactDOM.render(
          React.createElement(e.default, {
            pageSize,
            currentPageRef,
            noResults,
            placeholder,
            searchFor
          }),
          entrypoint
        );
      });
    });
  }
}
